<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all">
        <!-- 主体表格 -->
        <div class="mainTable height-all">
          <basetable tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="productList" :showopera="true" :currentPage="searchDataParam.pageNo" operaWidth="240"
                     :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true"
                     :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                     @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
            <template v-slot:linkCount="scope">
              <div class="progressBox" v-if="scope.scope.row.percentage != -1">
                <el-progress type="circle" :percentage="scope.scope.row.percentage" :width="20" :stroke-width="3" :show-text="false" color="#4A7FF8"></el-progress>
                <span>{{scope.scope.row.linkCountText}}</span>
              </div>
            </template>
            <template v-slot:opera="scope">
              <el-button  plain type="primary" size="small" class="tableOptionBtn" @click="downLoadFile(scope,$event)">下载</el-button>
              <el-button  plain type="danger" size="small" class="tableOptionBtn" @click="delFile(scope,$event)">删除</el-button>
            </template>
          </basetable>
        </div>
    </div>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
  inject: ['$http', '$api', '$utils','$userUtils'],
  name: "myFilesList",
  components: {
    baseSearch,
    basetable,
    basedialog,
    tableDataSelect,
  },
  data() {
    return{
      isLoading: false,
      tableTitle: [
        {
          label: '名称',
          prop: 'fileName',
          width: 370,
        }, {
          label: '文件大小',
          prop: 'fileSize',
        }, {
          label: '生成时间',
          prop: 'fileGenerateTime',
        }, {
          label: '文件状态',
          prop: 'fileStatusStr',
        }, {
          label: '下载次数',
          prop: 'fileDownloadCount',
        }, {
          label: '过期时间',
          prop: 'fileExpireTime',
        }
      ],
      productList: [],
      total: 0,
      searchDataParam:{
        pageNo:1,
        pageSize:20,
      },
      currentFileId: "",  //当前操作的文件ID
    }
  },
  mounted() {
    //获取我的文件列表
    this.getDownLoadRecordList();
  },

  methods:{
    /**
     * 获取我的文件列表
     */
    getDownLoadRecordList() {
      let that = this;
      that.isLoading = true;
      that.$http.post(that.$api.getDownLoadRecordListApi, {
        "pageNo": that.searchDataParam.pageNo,
        "pageSize": that.searchDataParam.pageSize
      }).then(res => {
        that.isLoading = false;
        if(res.code == 200) {
          if(that.searchDataParam.pageNo == 1) that.total = res.data.count;
          that.productList = res.data.list;

          //遍历数据，重置格式
          if(that.productList.length > 0) {
            that.productList.forEach((item, index) => {
              item.fileGenerateTime = that.$utils.isEmpty(item.fileGenerateTime) ? "--" : that.$utils.getDateTime(item.fileGenerateTime);
              item.fileExpireTime = that.$utils.isEmpty(item.fileExpireTime) ? "--" : that.$utils.getDateTime(item.fileExpireTime);

              //文件状态 0：生成中；1：已生成; 2: 生成失败
              if(item.fileStatus == 0) {
                item.fileStatusStr = "生成中";
              }else if(item.fileStatus == 1) {
                item.fileStatusStr = "已生成";
              }else if(item.fileStatus == 2) {
                item.fileStatusStr = "生成失败";
              }
            })
          }
        }
      })
    },
    /**
     * 设置页码
     */
    currentChange(val){
      this.searchDataParam.pageNo = val;
      this.getDownLoadRecordList()
    },
    /**
     * 设置页码
     */
    sizeChange(val){
      this.searchDataParam.pageSize = val;
      this.getDownLoadRecordList()
    },
    /**
     * 下载文件按钮点击事件
     * @param {Object} scope
     */
    downLoadFile(scope) {
      let that = this;
      that.currentFileId = scope.scope.row.id;

      that.$confirm('是否下载?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        that.$loading();
        that.$http.postArray(that.$api.downLoadRecordFileApi, {
          "fileId": that.currentFileId
        }).then(res => {
          that.$loading().close();
          let blob = new Blob([res], {
            type: 'application/vnd.ms-excel'
          })
          let fileName = scope.scope.row.fileName
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
          } else {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            //释放内存
            window.URL.revokeObjectURL(link.href)
          }
          //下载文件接口是异步操作，所以等待一秒后再重新加载列表数据
          setTimeout(function() {
            that.getDownLoadRecordList();
          }, 1000);
        })
      }).catch(() => {
        that.$message.warning("已取消！");
      });

      // let linkDiv = document.createElement("div");
      // linkDiv.setAttribute("id", "queryForm");
      // let exportForm = document.createElement("form");
      // exportForm.setAttribute("action", that.$api.downLoadRecordFileApi + "?fileId=" + scope.scope.row.id);
      // exportForm.setAttribute("method", "POST");
      // exportForm.innerHTML = linkDiv.innerHTML;
      // document.body.appendChild(exportForm);
      // exportForm.submit();
      // exportForm.remove();




    },
    /**
     * 删除按钮点击事件
     * @param {Object} scope
     */
    delFile(scope) {
      this.currentFileId = scope.scope.row.id;
      this.$confirm('确定要删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center:true
      }).then(() => {
        console.log('确定')
        this.confirmDelFile();
      }).catch(() => {
        console.log('取消')
      });
    },
    /**
     * 删除当前文件确定按钮点击事件
     */
    confirmDelFile() {
      let that = this;
      that.$loading();
      that.$http.post(that.$api.deleteOrderDownloadFileApi, {
        "id": that.currentFileId
      }).then(res => {
        that.$loading().close();
        if(res.code == 200) {
          that.$message.success("文件删除成功");
          that.getDownLoadRecordList();
        }
      })
    }
  },
}
</script>

<style>
  .mainCont .container{
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;
  }
</style>